import module from 'viaticos/module.js'
import template from './template.html'
import * as moment from 'moment'

export class ViaticosSharedViajeItemComponent {
  data
  onSelect

  $onInit () {
    this.mismoDia = moment(this.data.fecha_inicial).isSame(this.data.fecha_final)
    this.fechaInicial = moment(this.data.fecha_inicial).format('dddd D [de] MMMM [de] YYYY')
    this.fechaFinal = moment(this.data.fecha_final).format('dddd D [de] MMMM [de] YYYY')
  }
}

module.component('viaticosSharedViajeItem', {
  controller: ViaticosSharedViajeItemComponent,
  template,
  bindings: {
    data: '<',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/viaje/item/component.js